<template>
  <div class="prop-sentiment" id="prop-sentiment">
    <div class="title-row">
      <h2 title="Guests say">
        Guests say
      </h2>
      <div class="info">
        <svg class="ico">
          <use xlink:href="#info-icon"/>
        </svg>
        <div class="info-box">
          This summary has been generated using feedback from guests who have stayed at this property
        </div>
      </div>
    </div>
    <p v-if="reviewsAnalysis.overall_summary">
      {{ reviewsAnalysis.overall_summary }}
    </p>
    <div class="sentiments-block">
      <div class="sentiment" v-if="reviewsAnalysis.cleanliness_score || reviewsAnalysis.cleanliness_summary">
        <h4>Cleanliness</h4>
        <div class="progress-bar" :class="{full: reviewsAnalysis.cleanliness_score === 100}">
          <div v-if="reviewsAnalysis.cleanliness_score" class="score" :style="{ maxWidth: `${reviewsAnalysis.cleanliness_score}%` }"/>
          <div v-else class="score null" style="width: 0"/>
        </div>
        <p v-if="reviewsAnalysis.cleanliness_summary && reviewsAnalysis.cleanliness_score !== null">
          {{ reviewsAnalysis.cleanliness_summary }}
        </p>
        <p v-if="reviewsAnalysis.cleanliness_score === null">
          Unfortunately we’ve been unable assess this category comprehensively enough based on the reviews we’ve received from guests about this property.
        </p>
      </div>
      <div class="sentiment" v-if="reviewsAnalysis.location_score || reviewsAnalysis.location_summary">
        <h4>Location</h4>
        <div class="progress-bar" :class="{full: reviewsAnalysis.location_score === 100}">
          <div v-if="reviewsAnalysis.location_score" class="score" :style="{ maxWidth: `${reviewsAnalysis.location_score}%` }"/>
          <div v-else class="score null" style="width: 0"/>
        </div>
        <p v-if="reviewsAnalysis.location_summary && reviewsAnalysis.location_score !== null">
          {{ reviewsAnalysis.location_summary }}
        </p>
        <p v-if="reviewsAnalysis.location_score === null">
          Unfortunately we’ve been unable assess this category comprehensively enough based on the reviews we’ve received from guests about this property.
        </p>
      </div>
      <div class="sentiment" v-if="reviewsAnalysis.comfort_score || reviewsAnalysis.comfort_summary">
        <h4>Comfort</h4>
        <div class="progress-bar" :class="{full: reviewsAnalysis.comfort_score === 100}">
          <div v-if="reviewsAnalysis.comfort_score" class="score" :style="{ maxWidth: `${reviewsAnalysis.comfort_score}%` }"/>
          <div v-else class="score null" style="width: 0"/>
        </div>
        <p v-if="reviewsAnalysis.comfort_summary && reviewsAnalysis.comfort_score !== null">
          {{ reviewsAnalysis.comfort_summary }}
        </p>
        <p v-if="reviewsAnalysis.comfort_score === null">
          Unfortunately we’ve been unable assess this category comprehensively enough based on the reviews we’ve received from guests about this property.
        </p>
      </div>
      <div class="sentiment" v-if="reviewsAnalysis.facilities_score || reviewsAnalysis.facilities_summary">
        <h4>Facilities</h4>
        <div class="progress-bar" :class="{full: reviewsAnalysis.facilities_score === 100}">
          <div v-if="reviewsAnalysis.facilities_score" class="score" :style="{ maxWidth: `${reviewsAnalysis.facilities_score}%` }"/>
          <div v-else class="score null" style="width: 0"/>
        </div>
        <p v-if="reviewsAnalysis.facilities_summary && reviewsAnalysis.facilities_score !== null">
          {{ reviewsAnalysis.facilities_summary }}
        </p>
        <p v-if="reviewsAnalysis.facilities_score === null">
          Unfortunately we’ve been unable assess this category comprehensively enough based on the reviews we’ve received from guests about this property.
        </p>
      </div>
      <div class="sentiment" v-if="reviewsAnalysis.thoughtfulness_score || reviewsAnalysis.thoughtfulness_summary">
        <h4>Thoughtfulness</h4>
        <div class="progress-bar" :class="{full: reviewsAnalysis.thoughtfulness_score === 100}">
          <div v-if="reviewsAnalysis.thoughtfulness_score" class="score" :style="{ maxWidth: `${reviewsAnalysis.thoughtfulness_score}%` }"/>
          <div v-else class="score null" style="width: 0"/>
        </div>
        <p v-if="reviewsAnalysis.thoughtfulness_summary && reviewsAnalysis.thoughtfulness_score !== null">
          {{ reviewsAnalysis.thoughtfulness_summary }}
        </p>
        <p v-if="reviewsAnalysis.thoughtfulness_score === null">
          Unfortunately we’ve been unable assess this category comprehensively enough based on the reviews we’ve received from guests about this property.
        </p>
      </div>
    </div>
    <button @click="scrollTo">
      See Availability
    </button>
  </div>
</template>

<script>
export default {
  props: {
    reviewsAnalysis: Object
  },
  methods: {
    scrollTo() {
      this.$emit('scrollTo', 'availability-block', -20);
    },
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

@keyframes progress {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
};

.prop-sentiment {
  padding-bottom: 1.25rem;
  margin: 0 1.25rem 1.25rem;
  border-bottom: 1px solid #D9D9D9;

  .title-row {
    display: flex;
    margin: 1.25rem 0;
    position: relative;
    flex-direction: row;

    h2 {
      width: max-content;
      font-size: 1.25rem;
      line-height: 1.25rem;
    }

    .info {
      display: block;

      .info-box {
        left: 0;
        top: 2rem;
        display: none;
        padding: 0.5rem;
        color: $col_white;
        position: absolute;
        font-size: 0.875rem;
        line-height: 1.125rem;
        border-radius: 0.25rem;
        background: $col_darkgrey;
        width: calc(100% - 1.5rem);

        &:before {
          width: 0;
          height: 0;
          content: '';
          top: -0.5rem;
          left: 8.875rem;
          position: absolute;
          border-left: 0.5rem solid transparent;
          border-right: 0.5rem solid transparent;
          border-bottom: 0.5rem solid $col_darkgrey;
        }
      }

      &:hover {
        .info-box {
          display: block;
        }
      }

      svg {
        display: block;
        width: 0.75rem;
        height: 0.75rem;
        cursor: pointer;
        margin: 0.25rem 0 0 0.25rem;
      }
    }
  }

  h3 {
    font-size: 1.125rem;
    line-height: 1.125rem;
    margin: 1.25rem 0 1.25rem 0;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.125rem;
    margin-bottom: 1.25rem;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  button {
    display: block;
    padding: .5rem;
    cursor: pointer;
    transition: .3s;
    font-weight: 700;
    text-align: center;
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: $col_secondary;
    border-radius: .25rem;
    text-decoration: none;
    box-sizing: border-box;
    background: transparent;
    margin: 1.25rem 0 0 auto;
    border: 1px solid $col_secondary;

    &:hover {
      transition: .3s;
      color: $col_white;
      background: $col_secondary;
    }
  }

  .sentiments-block {
    padding-top: 1.25rem;
    h4 {
      margin-bottom: 0.5rem;
    }

    .sentiment {
      margin-bottom: 0.5rem;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .progress-bar {
      overflow: hidden;
      background: #d8d8d8;
      margin-bottom: 0.5rem;
      border-radius: 0 0.3rem 0.3rem 0;

      &.full {
        border-radius: 0.3rem;
      }

      .score {
        height: 0.5rem;
        background: $col_primary;
        animation-iteration-count: 1;
        animation: progress 2.5s linear;

        &.null {
          animation: none;
        }
      }
    }
  }

  @media #{$desktop} {
    margin: 0 0 1.25rem;

    .title-row {
      h2 {
        font-size: 1.5rem;
        line-height: 1.813rem;
      }

      .info {
        .info-box {
          left: 1.25rem;
          width: calc(100% - 8.5rem);

          &:before {
            left: 9.375rem;
          }
        }
      }
    }

    p {
      font-size: 1rem;
      line-height: 1.25rem;
    }

    button {
      font-size: 1rem;
      line-height: 1.25rem;
    }

    .sentiments-block {
      display: grid;
      grid-row-gap: 1.25rem;
      grid-column-gap: 2.25rem;
      grid-template-columns: 1fr 1fr;

      .sentiment {
        margin-bottom: 0;
      }
    }
  }
}
</style>